import { notifications } from '@mantine/notifications';
import classes from './notifications.module.css';
import { useTranslation } from 'react-i18next';

export const useCustomNotification = () => {
  const { t } = useTranslation('notifications');

  const notify = (e: any) => {
    const status = e?.response?.status;

    switch (status) {
      case 400: {
        notifications.show({
          title: t('title400'),
          message: e?.response?.data?.message || t('message400'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 401: {
        notifications.show({
          title: t('title401'),
          message: e?.response?.data?.message || t('message401'),
          color: 'red',
          classNames: classes,
        });
        // logout();
      }
      case 403: {
        notifications.show({
          title: t('title403'),
          message: e?.response?.data?.message || t('message403'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 404: {
        notifications.show({
          title: t('title404'),
          message: e?.response?.data?.message || t('message404'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 422: {
        notifications.show({
          title: t('title422'),
          message: e?.response?.data?.message || t('message422'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 500: {
        notifications.show({
          title: t('title500'),
          message: e?.response?.data?.message || t('message500'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 502: {
        notifications.show({
          title: t('title502'),
          message: e?.response?.data?.message || t('message502'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 503: {
        notifications.show({
          title: t('title503'),
          message: e?.response?.data?.message || t('message503'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 504: {
        notifications.show({
          title: t('title504'),
          message: e?.response?.data?.message || t('message504'),
          color: 'red',
          classNames: classes,
        });
        return;
      }
      case 522: {
        notifications.show({
          title: t('title522'),
          message: e?.response?.data?.message || t('message522'),
          color: 'red',
          classNames: classes,
        });
        return;
      }

      default: {
        notifications.show({
          title: t('system'),
          message: t('message'),
          color: 'red',
          classNames: classes,
        });
      }
    }
  };

  const updateNotify = (e: any, id?: string) => {
    const status = e?.response?.status;

    switch (status) {
      case 400: {
        notifications.update({
          id: id,
          title: t('title400'),
          message: e?.response?.data?.message || t('message400'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 401: {
        notifications.update({
          id: id,
          title: t('title401'),
          message: e?.response?.data?.message || t('message401'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        // logout();
      }
      case 403: {
        notifications.update({
          id: id,
          title: t('title403'),
          message: e?.response?.data?.message || t('message403'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 404: {
        notifications.update({
          id: id,
          title: t('title404'),
          message: e?.response?.data?.message || t('message404'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 422: {
        notifications.update({
          id: id,
          title: t('title422'),
          message: e?.response?.data?.message || t('message422'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 500: {
        notifications.update({
          id: id,
          title: t('title500'),
          message: e?.response?.data?.message || t('message500'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 502: {
        notifications.update({
          id: id,
          title: t('title502'),
          message: e?.response?.data?.message || t('message502'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 503: {
        notifications.update({
          id: id,
          title: t('title503'),
          message: e?.response?.data?.message || t('message503'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 504: {
        notifications.update({
          id: id,
          title: t('title504'),
          message: e?.response?.data?.message || t('message504'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }
      case 522: {
        notifications.update({
          id: id,
          title: t('title522'),
          message: e?.response?.data?.message || t('message522'),
          color: 'red',
          classNames: classes,
          loading: false
        });
        return;
      }

      default: {
        notifications.update({
          id: id,
          title: t('system'),
          message: t('message'),
          color: 'red',
          classNames: classes,
          loading: false
        });
      }
    }
  };

  return { notify, updateNotify };
};

export function createNotification({
  id,
  type,
  message,
  title,
  withLoading = false,
  autoClose
}: {
  id?: string
  type: 'error' | 'success' | 'info';
  title: string;
  message: string;
  withLoading?: boolean;
  autoClose?: boolean | number | undefined
}) {
  const color: Record<'error' | 'success' | 'info', string> = {
    error: 'red',
    success: 'green',
    info: 'blue',
  };
  notifications.show({
    id: id,
    title: title,
    message: message,
    color: color[type],
    classNames: classes,
    loading: withLoading,
    autoClose: autoClose
  });
}

export function updateNotification({
  id,
  type,
  message,
  title,
  autoClose,
  icon
}: {
  id?: string
  type: 'error' | 'success' | 'info';
  title: string;
  message: string;
  autoClose?: boolean | number | undefined,
  icon?: any
}) {
  const color: Record<'error' | 'success' | 'info', string> = {
    error: 'red',
    success: 'green',
    info: 'blue',
  };
  notifications.update({
    id: id,
    title: title,
    message: message,
    color: color[type],
    classNames: classes,
    autoClose: autoClose,
    loading: false,
    icon: icon
  });
}
